import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Blue90};
  padding: 12px 16px 12px 12px;
  gap: 12px;
  border-radius: 8px;
  background-color: ${Colors.Blue10};
  align-items: center;
`

export const Img = styled.img`
  margin: 28px;
  width: 29px;
  margin: 4px;
`
